import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import { File } from 'components/Media/File'
import LeftIcon from './icons/leftIcon'
import RightIcon from './icons/rightIcon'
import { css } from 'aphrodite'
import styles from './styles'
import latestFiles from 'modules/Media/computed/latestFiles'
import { t } from '@billes/translator-client'

export default connect(
  {
    client: state`app.client.name`,
    startIndex: state`startPage.startIndex`,
    latestFiles: latestFiles
  },
  class Latest extends Component {
    render() {
      const { latestFiles, startIndex } = this.props

      const latestComponents = latestFiles
        .slice(startIndex, startIndex + 5)
        .map(function(file, index) {
          return (
            <div
              key={index}
              style={{
                width: 190
              }}
            >
              <File path={`media.files.${file.id}`} clickable={false} />
            </div>
          )
        })
      return (
        <div className={css(styles.latest)}>
          <div className={css(styles.headline)}>
            {t('bms.startpage.latestFiles')}
          </div>
          <div className={css(styles.mediaWrapper)}>
            <LeftIcon />
            <div
              style={{
                height: 225,
                display: 'flex',
                width: '100%'
              }}
            >
              {latestComponents}
            </div>
            <RightIcon fileCount={latestFiles.length} />
          </div>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/StartPage/Latest/latest.js